import styled from 'styled-components'
import getPalette from '../../../helpers/colors/colors'
import getFont from '../../../helpers/fonts/fonts'

const palette = getPalette()

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	padding: 6% 10%;
`

const AvatarButton = styled.div`
	width: 100%;
	height: 100%;
	border: none;
	border-radius: 16%;
	box-shadow: rgba(0, 0, 0, 0.05) 0px 6% 0px;
	cursor: pointer;
	transition: box-shadow 0.25s ease-out;
	position: relative;

	&:hover {
		box-shadow: rgba(0, 0, 0, 0.05) 0px 8% 0px;
	}
`

const AvatarComingSoon = styled.div`
	width: 126%;
	border: none;
	color: ${palette.white};
	font-family: ${getFont('primaryHeavy')};
	font-size: 24%;
	text-align: center;
	position: absolute;
	top: -10%;
	left: -13%;
`

const AvatarDate = styled(AvatarComingSoon)`
	top: inherit;
	bottom: -10%;
`

export { Wrapper, AvatarButton, AvatarComingSoon, AvatarDate }
